import { render, staticRenderFns } from "./snippets-summary-page.vue?vue&type=template&id=940289ac&scoped=true&"
import script from "./snippets-summary-page.vue?vue&type=script&lang=js&"
export * from "./snippets-summary-page.vue?vue&type=script&lang=js&"
import style0 from "./snippets-summary-page.vue?vue&type=style&index=0&id=940289ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940289ac",
  null
  
)

export default component.exports